var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-radio-group',{staticClass:"mt-0 float-left ml-3",attrs:{"value":_setup.props.value,"row":""},on:{"change":_vm.setCalculationType}},_vm._l((_setup.props.options),function(option){return _c('v-radio',{key:option.value,attrs:{"label":option.label,"value":option.value}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }